import React from 'react'
import ReactDOM from 'react-dom/client'
import 'styles/globals.scss'
import App from './App'

const root = ReactDOM.createRoot(document.querySelector('#root')!)

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
